'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _error = require('./error');

var _productNotFound = require('./product-not-found');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('app.error', ['ng']).config(["$stateProvider", function ($stateProvider) {
    'ngInject';

    $stateProvider.state('error', {
        parent: 'master',
        url: '/error',
        views: {
            'main@root': {
                component: 'error'
            },
            'header@root': '',
            'aside@root': '',
            'menu@root': '',
            'submenu@root': '',
            'footer@root': ''
        },
        params: {
            message: null
        },
        data: {
            public: true
        }
    }).state('error-product', {
        parent: 'master',
        url: '/productNotFound',
        views: {
            'main@root': {
                component: 'productNotFound'
            },
            'header@root': '',
            'aside@root': '',
            'menu@root': '',
            'submenu@root': '',
            'footer@root': ''
        },
        data: {
            public: true
        }
    });
}]).component('error', _error.errorComponent).component('productNotFound', _productNotFound.productNotFoundComponent);

exports.default = _module.name;


//////////////////
// WEBPACK FOOTER
// ./features/error/index.js
// module id = 930
// module chunks = 0